import { Component, OnInit, Inject } from '@angular/core';


import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { FinanzasService } from 'app/finanzas/finanzas.service';

import { Router } from '@angular/router';

import { Puc, Empresa } from 'app/finanzas/entidades';

import { PucComponent } from '../puc/puc.component';

@Component({
  selector: 'app-consultaFecha',
  templateUrl: './consultaFecha.component.html',
  styleUrls: ['./consultaFecha.component.css']
})
export class ConsultaFechaComponent implements OnInit {

  empresa: Empresa = new Empresa();
  
  cuenta : Puc = new Puc();
  
  vista : boolean = true;   

  puc : Array<Puc>;  // Este array contiene los registros de la tabla finanzaspuc
  
  anio_m_mv  =  new Date().getFullYear();   //  anio  movimientos por mes
  mes_m_mv  = new Date().getMonth()+1;   // mes   movimiento por mes
  anio_mv = new Date().getFullYear();     // anio movimiento por anio 
  anio_m_ce = new Date().getFullYear();    // anio comprobante por mes
  mes_m_ce  = new Date().getMonth()+1;     // mes comprobante por mes
  anio_ce_a = new Date().getFullYear();    // anio comprobante por anio  


  constructor(
    public dialog : MatDialog,
    public dialogRef : MatDialogRef<ConsultaFechaComponent>,
    @Inject(MAT_DIALOG_DATA) private datos, 
    private servicios : FinanzasService, 
    private router: Router, 
    ) { 

    }

  ngOnInit() {
    this.servicios.getPuc( this.definirEmpresa()  )
      .subscribe((resp :Array<Puc>) => {
        this.puc = resp 
    }) 
  }

  Puc(): void {
    const dialogRef = this.dialog.open(PucComponent, {
      width: '500px',
      height: '550px',
      data :{
        empresa: this.datos.empresa.id_empresa,
        idEmpresa: this.datos.empresa,
        puc : this.puc, 
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  definirEmpresa(){     
    if (  this.datos.empresa.id_empresa != undefined  ){
      const empresaTemp = this.datos.empresa.id_empresa; return empresaTemp;
    }
    else {
      const empresaTemp = this.datos.empresa; return empresaTemp;
    }
  }

  // ver movimientos por mes
  verBitacora() {
    const empresa = this.definirEmpresa();
    const anio_actual = new Date().getFullYear();
    let anio = this.anio_m_mv;
    const mes = this.mes_m_mv;

    if(anio == undefined || anio == 0 ){
      anio  = anio_actual
    }
    
    this.router.navigate(["finanzas/movimientos"], { queryParams: { empresa , anio, mes }  }  ) ;
    
  }

  // ver movimiento por anio 
  verBitacoraAnio( ){
    const empresa = this.definirEmpresa();
    const anio = this.anio_mv;
    this.router.navigate(  ["finanzas/movimientosAnio"], { queryParams: { empresa, anio } }  )  ;
  }


  verComprobante() {
    const empresa  = this.definirEmpresa();
    const anio_actual = new Date().getFullYear();
    let anio = this.anio_m_ce;
    const mes = this.mes_m_ce;
    if(anio == undefined || anio == 0 ){
      anio  = anio_actual
    }
    this.router.navigate(["finanzas/comprobante"], { queryParams: { empresa , anio, mes } });
  }

  verComprobanteAnio(){
    const empresa = this.definirEmpresa();
    const anio = this.anio_ce_a;
    this.router.navigate(["finanzas/comprobanteAnio"], { queryParams: { empresa, anio } });
  }

}
